import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
// CSS
import "./index.scss";

function Wrapper({ children, heading, subheading, icon, link, padded, action }) {
	return (
		<div className="dashboard-element">
			<div className="dashboard-element--header">
				<div className="dashboard-element--header--left">
					<div className="p2 main">
						{icon ?? false ? (
							<img
								src={icon}
								alt="icon"
							/>
						) : (
							""
						)}
						{heading}
					</div>
					{subheading ?? <div className="p4 sub">{subheading}</div>}
				</div>
				{link ?? false ? (
					<Link
						className="dashboard-nav-link p4 strong"
						to={link.to}
					>
						{link.text}
					</Link>
				) : (
					""
				)}
				{action ?? null}
			</div>
			<div className={`dashboard-element--body ${padded ?? false ? "padded" : ""}`}>{children}</div>
		</div>
	);
}

Wrapper.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	heading: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
	subheading: PropTypes.string,
	icon: PropTypes.string,
	link: PropTypes.object,
	padded: PropTypes.bool,
	/** Control rendered at the right of the header (e.g. the chart's date-range dropdown). */
	action: PropTypes.node,
};
export default Wrapper;
